// Arrays
const { partitionArray } = require("./arrays/array-services");

// Cart
const { parseResponse } = require("./cart/cart-services");

// Content
const { createContentFactory } = require("./data/content-factory");

// Languages
const {
    languageFormatEfigs,
    languageFormatOther,
    languageFormatMobile
} = require("./languages/format-language-services");

// Navigation & URLs
const { queryStringToJson } = require("./site/navigation-services");

// Resources
const { resourcesTitleSort, resourcesTrimTitle } = require("./resources/title-services");
const { addTrailingSlash } = require("./site/url-services");

// Verticals
const { deriveLinks } = require("./verticals/verticals-services");

// Gatsby Site
const {
    calcAnchorNavWidth,
    disableScroll,
    enableScroll,
    navigateTo,
    preventDefault
} = require("./site/navigation-services");

module.exports = {
    arrayServices: { partitionArray },
    cartServices: { parseResponse },
    contentServices: { createContentFactory },
    languageServices: { languageFormatEfigs, languageFormatOther, languageFormatMobile },
    navigationServices: { queryStringToJson },
    resourceServices: { resourcesTitleSort, resourcesTrimTitle },
    siteServices: { calcAnchorNavWidth, disableScroll, enableScroll, navigateTo, preventDefault, queryStringToJson },
    urlServices: { addTrailingSlash },
    verticalServices: { deriveLinks }
};
